import { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import InputField from '@/UIlibrary/InputField/InputField';
import Button from '@/UIlibrary/Button/Button';
import { Typography } from '@/UIlibrary/Typography/Typography';
import Logo from '@/stories/Components/Logo/Logo';
import { SignInParams } from '@/types/api/ControlDesk';
import jsonAPI from '@/../axiosClient';
import { useTranslations } from 'use-intl';
import useAuthStore from '@/lib/auth';

type LoginProps = {
	message?: string | null;
	prefilledEmail?: string;
	showOnboardMesage?: boolean;
};

const Login: React.FC<LoginProps> = ({ message, prefilledEmail = '', showOnboardMesage }) => {
	const [formData, setFormData] = useState({
		email: prefilledEmail,
		password: ''
	});
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const { setToken } = useAuthStore();
	const t = useTranslations('Login');

	const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		setLoading(true);

		const body: SignInParams = {
			data: {
				attributes: {
					email: formData.email,
					password: formData.password
				},
				relationships: {},
				type: 'control_desk'
			}
		};
		try {
			const response = await jsonAPI.post('/control-desk/sign-in', body);
			if (response.data?.meta?.token) {
				setToken(response.data.meta.token);
			}
		} catch (status) {
			if (status === 403) {
				setError(t('InvalidCredentials'));
			}
		}
		setLoading(false);
	};
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		setFormData((prevFormData) => ({
			...prevFormData,
			[name]: value
		}));
	};

	useEffect(() => {
		if (message) {
			toast.error(message, { duration: 15000 });
		}
	}, [message]);

	useEffect(() => {
		if (showOnboardMesage) {
			toast.success(t('AccountMustBeApproved'), { duration: 15000 });
		}
	});

	return (
		<div
			className="flex min-h-screen"
			style={{
				background: `linear-gradient(to right top, #1e6091, #184e7d, #123d69, #0b2d55, #041e42)`
			}}
		>
			<div className="w-full flex justify-center items-center ">
				<form
					className="flex flex-col w-11/12 md:w-full max-w-[452px] mx-auto bg-[#FFFFFF] py-12 px-11 rounded-[25px] gap-8"
					onSubmit={handleSubmit}
				>
					<div className="flex flex-row justify-center">
						<Logo src="/logo.svg" width={170} height={50} />
					</div>
					<div className="flex flex-col gap-8">
						<Typography size="sm" type="display" weight="semibold">
							{t('Welcome')}
						</Typography>
						<div className="flex flex-col gap-2">
							<InputField
								name="email"
								label={'Email'}
								value={formData.email}
								onChange={handleChange}
								loading={loading}
								disabled={loading}
								placeholder="email@fincluyente.com"
								size={'auto'}
								error={!!error}
								focused={true}
							/>
							<InputField
								name="password"
								type="password"
								label={t('Password')}
								value={formData.password}
								onChange={handleChange}
								loading={loading}
								size={'auto'}
								placeholder={t('Password')}
								error={!!error}
								hint={error || ''}
							/>
							<a href="#" className="py-2">
								<Typography size="sm" weight="semibold" color="brand">
									{t('ForgotPassword')}
								</Typography>
							</a>
							<Button
								dataTestId="loginButton"
								disabled={formData.password === '' || loading}
								label={t('Login')}
								size="auto"
								type="submit"
							/>
						</div>
						<div className="flex flex-row gap-1 justify-end">
							<Typography color="subtitle" size="sm">
								{t('Powered')}
							</Typography>
							<Logo src="/orkestus-text-logo.svg" width={110} height={25} />
						</div>
					</div>
				</form>
			</div>
		</div>
	);
};

export default Login;
